import React from "react";
import styles from "./Banner.module.css";

const Banner = () => {
  return (
    <section className={styles.imgbox}>
      <div className={styles.content}>
        <p data-aos="fade-down" className={styles.text}>
          Your Vision Our Solution.
        </p>
        <p className={styles.imageText2}>Where Excellence Meets Innovation.</p>
      </div>
    </section>
  );
};

export default Banner;
